import React from 'react';

const PercentageFormatter = ({ value }) => {
  if (typeof value !== 'number') return <span>—</span>;  // or return null or "0.0%" depending on your style

  const formattedValue = `${(value * 100).toFixed(1)}%`; // optional: multiply by 100 if value is decimal

  return <span>{formattedValue}</span>;
};

export default PercentageFormatter;
